import React from 'react'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'
import { type SingleColumnBlok } from '@/components/Header/New/SingleColumn'
import { type NavItemGroup, type NavItem } from '@/components/Header/New/nav'
export const SingleColumn = (menu: SingleColumnBlok) => {
  return (
    <div className="grid grid-cols-1 gap-4">
      <span className="text-lg font-bold text-darkblue">
        {menu.label || menu.menu_label}
      </span>

      <div className="grid grid-cols-1 gap-4 w-screen max-w-max">
        {menu.items &&
          menu.items.map((item: NavItemGroup, idx: number) => {
            return (
              <div key={idx} className="grid grid-cols-1 gap-4 mt-2">
                <Link
                  className="text-sm font-semibold uppercase text-brightgreen hover:text-brightgreen/50"
                  to={resolveLink(item.group_label_link)}
                >
                  {item.group_label}
                </Link>
                {item.group_links &&
                  item.group_links.map((subItem: NavItem, subIdx) => {
                    return (
                      <div key={subIdx}>
                        <Link
                          className="bg-gray-200/80 text-sm text-darkblue hover:text-brightgreen rounded-full py-2 px-4"
                          to={resolveLink(subItem.link)}
                        >
                          {subItem.text}
                        </Link>
                      </div>
                    )
                  })}
              </div>
            )
          })}
      </div>
    </div>
  )
}
